import { addBreadcrumb, captureError } from '@/lib/sentry';

function formatArg(value: unknown): string {
  if (value instanceof Error) {
    return value.message;
  }
  if (typeof value === 'string') {
    return value;
  }
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

function formatArgs(args: unknown[]): string {
  return args.map(formatArg).filter((part) => part.length > 0).join(' ');
}

export function logInfo(...args: unknown[]): void {
  const message = formatArgs(args);
  if (!message) return;
  addBreadcrumb(message, 'log', 'info');
}

export function logWarn(...args: unknown[]): void {
  const message = formatArgs(args);
  if (!message) return;
  addBreadcrumb(message, 'log', 'warning');
}

export function logError(...args: unknown[]): void {
  if (args.length === 0) return;

  const errorArg = args.find((arg) => arg instanceof Error) as Error | undefined;
  const message = formatArgs(args);
  const error = errorArg ?? new Error(message || 'Unknown error');

  if (import.meta.env.MODE !== 'production') {
    console.error(...args);
  }

  captureError(error, {
    args: args.map((arg) => (arg instanceof Error ? arg.message : formatArg(arg))),
  });
}
